import React from 'react';

function Section({ id, tone = 'paper', className = '', children }) {
  const classes = ['band', `band--${tone}`, className].filter(Boolean).join(' ');

  return (
    <section id={id} className={classes}>
      <div className="site-container">{children}</div>
    </section>
  );
}

export default Section;
